/**
 * Palette colors.
 * @enum {string}
 */
export const colors = {}

export const indicatorColors = {
  a0: '#801641',
  a1: '#E4538E',
  b0: '#201048',
  b1: '#4430A0',
  b2: '#744FF5',
  b3: '#A293E3',
  c0: '#243003',
  c1: '#495D0D',
  c2: '#93AC21',
  c3: '#BDC75E',
  d0: '#033A39',
  d1: '#11817F',
  d2: '#1EBAB7',
  d3: '#74D9D6',
  e0: '#5A1605',
  e1: '#963D0F',
  e2: '#D1682B',
  e3: '#F99053',
}

export const serviceCBarColors = ['#B94E38', '#0C2FDB', '#A5AD63', '#062183']
